import React, { FC } from 'react';

import { Box } from '@mui/material';

import getLongTermContractLabels from '../../../../common/LongTermContractLabels/LongTermContractLabels';
import strings from '../../../../../localization';
import WithSkeleton from '../../../../common/WithSkeleton';

import styles from './styles';

interface IShiftIdentifier {
  bookedShiftCount?: number;
  totalShiftCount?: number;
  isLongTerm?: boolean;
  contractStartDate?: string;
  contractEndDate?: string;
  successAction: string;
}

const ShiftIdentifier: FC<IShiftIdentifier> = ({
  contractStartDate = '',
  bookedShiftCount = 0,
  contractEndDate = '',
  totalShiftCount = 0,
  isLongTerm,
  successAction,
}) => {
  const SkeletonBox = WithSkeleton({
    successAction,
    variant: 'rectangular',
    height: 30,
    width: 400,
  })(Box);

  const remaining = totalShiftCount - bookedShiftCount;

  let multipleLabel = `${strings.multipleShifts}`;

  if (remaining > 0) {
    multipleLabel += ` (${remaining}/${totalShiftCount} ${strings.daysRemaining})`;
  }

  const { ShiftLabel, RangeLabel } = getLongTermContractLabels({
    contractEndDate,
    contractStartDate,
    isLongTerm,
    successAction,
    customMultipleLabel: multipleLabel,
  });

  return (
    <SkeletonBox sx={styles.shiftTypeContainer}>
      <ShiftLabel />
      {isLongTerm && <RangeLabel />}
    </SkeletonBox>
  );
};

export default ShiftIdentifier;
